"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var styles_scss_1 = tslib_1.__importDefault(require("./styles.scss"));
var inline_icon_1 = tslib_1.__importDefault(require("../inline-icon/inline-icon"));
var ArrowDownIcon_1 = tslib_1.__importDefault(require("../../../icons/compiled/components/ArrowDownIcon"));
var Select = /** @class */ (function (_super) {
    tslib_1.__extends(Select, _super);
    function Select() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Select.prototype.render = function () {
        var _a;
        var _b = this.props, options = _b.options, disabled = _b.disabled, dataHook = _b.dataHook, className = _b.className, ariaLabel = _b.ariaLabel, onChange = _b.onChange, selected = _b.selected, isRTL = _b.isRTL;
        var arrowDownStyles = (0, classnames_1.default)(styles_scss_1.default.arrowDown, (_a = {},
            _a[styles_scss_1.default.rtl] = isRTL,
            _a[styles_scss_1.default.ltr] = !isRTL,
            _a));
        return (react_1.default.createElement("div", { className: "".concat(styles_scss_1.default.wrapper, " ").concat(className), "aria-label": ariaLabel },
            react_1.default.createElement(inline_icon_1.default, { className: arrowDownStyles, icon: react_1.default.createElement(ArrowDownIcon_1.default, null) }),
            react_1.default.createElement("select", { "data-hook": dataHook, className: styles_scss_1.default.select, onChange: onChange, value: selected || '', disabled: disabled }, options.map(function (opt) { return (react_1.default.createElement("option", { key: opt.value, value: opt.value }, opt.text)); }))));
    };
    Select.defaultProps = {
        options: [],
        onChange: function () { },
        disabled: false,
        isRTL: false,
    };
    return Select;
}(react_1.default.Component));
exports.default = Select;
//# sourceMappingURL=select.js.map